import { prettifyPathname } from './prettifyPathname.js';

export const getRouteName = (pathname: string): string => {
  return prettifyPathname(pathname) === ''
    ? 'ip_profile'
    : `ip_${prettifyPathname(pathname)}`;
};
